import React, { useEffect, useState, useRef } from "react";
import { Link } from "react-router-dom";
import "./NewsSection.css";
import { FaSearch } from "react-icons/fa";
import { AsyncImage } from "loadable-image";
import FadeUp from "../FadeUp/FadeUp";
import newsData from "../../data/news.json";

const NewsSection = ({ isAlbanian }) => {
  const [news, setNews] = useState([]);
  const [newsSearch, setNewsSearch] = useState([]);
  const [filteredNews, setFilteredNews] = useState([]);
  const [filterType, setFilterType] = useState(null);
  const [searchTitle, setSearchTitle] = useState("");
  const imagesLoaded = useRef(0);

  useEffect(() => {
    setNews(newsData);
    setFilteredNews(newsData);
  }, []);

  const filterNewsButton = (type) => {
    setFilterType(type);
    if (type) {
      setFilteredNews(news.filter((item) => item.news_type === type));
    } else {
      setFilteredNews(news);
    }
  };

  const filterNews = () => {
    let filtered = news;
    if (filterType) {
      filtered = filtered.filter((item) => item.news_type === filterType);
    }
    if (searchTitle.trim()) {
      filtered = filtered.filter((item) =>
        (isAlbanian ? item.titull_lajmesh : item.news_title)
          .toLowerCase()
          .includes(searchTitle.toLowerCase())
      );
    }
    setFilteredNews(filtered);
  };

  const handleImageLoad = () => {
    imagesLoaded.current += 1;
  };

  return (
    <div>
      <div className="newssection-container">
        <div className="overlay">
          <div className="vertical-line left"></div>
          <div className="vertical-line right"></div>
          <div className="news-search">
            <div className="search-news">
              <div className="search-container">
                <FaSearch className="search-icon" />
                <input
                  type="text"
                  placeholder={isAlbanian ? "Kërko një lajm" : "Search news"}
                  value={searchTitle}
                  onChange={(e) => setSearchTitle(e.target.value)}
                  onKeyPress={(e) => e.key === "Enter" && filterNews()}
                />
                {searchTitle && (
                  <button className="search-button" onClick={filterNews}>
                    <img
                      src="/arrowsearch.png"
                      alt="arrowsearch"
                      className="arrowsearch"
                    />
                  </button>
                )}
              </div>
            </div>
            <div className="news-buttons">
              <div className="news-button">
                <button onClick={() => filterNewsButton("news")}>News</button>
              </div>
              <div className="news-event">
                <button onClick={() => filterNewsButton("event")}>Event</button>
              </div>
            </div>
            <div className="news-third-part"></div>
          </div>
          <div className="newssection-title">
            {isAlbanian ? "Lajme" : "News & Insight"}
          </div>
          <div className="bottom-line"></div>
        </div>
        <div className="newssection-grid">
          {filteredNews.map((project) => (
            <FadeUp key={project.news_id}>
              <Link
                className="newssection-card"
                key={project.news_id}
                to={`/newsdetails/${project.news_id}`}
                onClick={(e) => {
                  if (!e.ctrlKey && !e.metaKey) {
                    e.preventDefault();
                    window.location.href = `/newsdetails/${project.news_id}`;
                  }
                }}
              >
                <div className="type-card">{project.news}</div>
                <div className="newssection-image-square">
                  <AsyncImage
                    src={project.news_image_url}
                    alt={project.news_title}
                    className="newssection-image"
                    loading="lazy"
                    onLoad={handleImageLoad}
                  />
                </div>
                <div className="newssection-content">
                  <h3 className="newssectioncard-title">
                    {isAlbanian ? project.titull_lajmesh : project.news_title}
                  </h3>
                  <p className="newssection-address">
                    {isAlbanian
                      ? project.pershkrim_lajmesh.slice(0, 80) +
                        (project.pershkrim_lajmesh.length > 90 ? "..." : "")
                      : project.news_description.slice(0, 80) +
                        (project.news_description.length > 90 ? "..." : "")}
                  </p>
                  <p className="newssection-lookmore">
                    {isAlbanian ? "Shiko më shumë →" : "Look more →"}
                  </p>
                </div>
              </Link>
            </FadeUp>
          ))}
        </div>
      </div>
    </div>
  );
};

export default NewsSection;
